import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_POLICIES',
  'CREATE_POLICY',
  'DELETE_POLICY',
  'UPDATE_POLICY',
]);
